import * as Cookies from "es-cookie"
import InformationDataJa from "assets/locales/ja/information/InformationData.json"

// cookieの値を数値に変換
export const parseToNum = (version) => {
  // undefined・文字列 → NaN
  // 空文字 → 0
  const num = Number(version)
  return isNaN(num) ? 0 : num
}

export const getLatestRelease = () => {
  let releaseNoArray

  releaseNoArray = InformationDataJa.concat().map((item) =>
    parseToNum(item.infoReleaseVer)
  )
  return Math.max(...releaseNoArray)
}

export const getReadCookie = () => {
  return parseToNum(Cookies.get("read"))
}

export const setReadCookie = (props) => {
  Cookies.set("read", props, { expires: 365 })
}
